<ng-container *transloco="let t;">
<ng-scrollbar autoHeightDisabled="false" visibility="hover" class="sidebar-content-scrollbar">
    <div class="signing-more-tab">
        <!-- <app-skeleton [loop]="2" [section]="'more-tab-signing-sidebar-loader'"></app-skeleton> -->
        <div class="media-list add-recipients">
            @if (roleDetail.allow_to_invite === 1) {
                <div class="media parties-box mb-2 px-1" (click)="inviteToSign()" [ngClass]="{'pointer-none opacity-25':![signingStatusEnum.SENT, signingStatusEnum.DELIVERED, signingStatusEnum.VIEWED, signingStatusEnum.READONLY].includes(roleDetail.recipient_role_detail.status)}">
                    <a class="media-left" href="javascript:void(0)">
                        <i class="bi bi-envelope-paper"></i>
                    </a>
                    <div class="media-body">
                        <h6 class="fw-bold d-block text-nowrap mb-25 sidebar-parties-name"> 
                            {{t("More tab invite to sign text (More tab) - Invite to sign")}}
                        </h6>
                        <small>{{t("More tab invite people message (More tab) - You can invite people to sign this document. their activity will appear on the activity feed")}}.</small>
                    </div>
                </div>    
            }
            @if (roleDetail.allow_to_read === 1) {
                <div class="media parties-box mb-2 px-1" (click)="inviteToRead()" [ngClass]="{'pointer-none opacity-25':![signingStatusEnum.SENT, signingStatusEnum.DELIVERED, signingStatusEnum.VIEWED, signingStatusEnum.READONLY].includes(roleDetail.recipient_role_detail.status)}">
                    <a class="media-left" href="javascript:void(0)">
                        <i class="bi bi-book"></i>
                    </a>
                    <div class="media-body">
                        <h6 class="fw-bold d-block text-nowrap mb-25 sidebar-parties-name"> 
                            {{t("More tab invite to read text (More tab) - Invite to read")}}
                        </h6>
                        <small>{{t("More tab invite people message (More tab) - You can invite people to read this document. their activity will appear on the activity feed")}}.</small>
                    </div>
                </div>    
            }
    
            
            <div class="media parties-box mb-2 px-1" (click)="rejectDocument()" [ngClass]="{'pointer-none opacity-25':![signingStatusEnum.SENT, signingStatusEnum.DELIVERED, signingStatusEnum.VIEWED, signingStatusEnum.READONLY].includes(roleDetail.recipient_role_detail.status)}">
                <a class="media-left" href="javascript:void(0)">
                    <i class="bi bi-exclamation-square"></i>
                </a>
                <div class="media-body">
                    <h6 class="fw-bold d-block text-nowrap mb-25 sidebar-parties-name"> 
                        {{t("More tab reject text (More tab) - Reject contract")}}
                    </h6>
                    <small>{{t("More tab reject message (More tab) - By rejecting the contract you notify the sender that you don't want to participate in this document")}}.</small>
                </div>
            </div>
            @if (roleDetail.allow_to_forward === 1) {
                <div class="media parties-box mb-2 px-1" (click)="forwardSignature()" [ngClass]="{'pointer-none opacity-25':(![signingStatusEnum.SENT, signingStatusEnum.DELIVERED, signingStatusEnum.VIEWED, signingStatusEnum.READONLY].includes(roleDetail.recipient_role_detail.status) || ['forward', 'invite'].includes(roleDetail.recipient_role_detail.part_by))}">
                    <a class="media-left" href="javascript:void(0)">
                        <i class="bi bi-forward"></i>
                    </a>
                    <div class="media-body">
                        <h6 class="fw-bold d-block text-nowrap mb-25 sidebar-parties-name"> 
                            {{t("More tab forward signature (More tab) - Forward signature")}}
                        </h6>
                        <small>{{t("More tab forward description (More tab) - Forward signature description here")}}</small>
                    </div>
                </div>
            }
        </div>
    </div>
</ng-scrollbar>
</ng-container>